import { Component } from '@angular/core';

/**
 * Former entry point of the toasts, kept so existing templates still compile: it draws nothing.
 * `MibToastService` draws the stack on its own the first time a toast is shown.
 */
@Component({
  selector: 'mib-toast, mib-toast-container',
  template: '',
})
export class MibToastContainer {}
